import { FolderFilled } from "@ant-design/icons";
import { Modal, Tooltip } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { Alert } from "rsuite";
import fileIcon from "../assets/images/file-lib.png";
import RbacModal from "../components/rbacmodal";
import constants from "../constants";
import { Context } from "../Context";

export default class LibraryModal extends Component {
    static contextType = Context;
    constructor(props) {
        super(props);
        this.state = {
            selected: [],
            openFolder: false,
            folder: "",
            editFolder: {},
        };
    }

    onSelect = (url, index) => {
        const selected = this.state.selected;
        const check = selected.find((o) => o.index === index);
        if (!check) {
            selected.push({ url: url, index: index });
        } else {
            const getIndex = selected.findIndex((o) => o.index === index);
            selected.splice(getIndex, 1);
        }
        this.setState({ selected });
    };

    save = () => {
        const urls = [];
        for (const i of this.state.selected) {
            urls.push(i.url);
        }
        this.props.selected_image(urls);
        this.cancel();
    };

    cancel = () => {
        this.setState({ selected: [] });
        this.props.onCancel();
    };

    onFolderSelect = (data) => {
        console.log(data);
        this.setState({ openFolder: true, editFolder: data });
    };

    openRbacFolder = () => {
        this.setState({ openFolder: true });
    };

    closeRbacFolder = () => {
        this.setState({ openFolder: false, editFolder: {} });
    };

    selectedFolder = (val) => {
        console.log("Forder ", val);
        this.setState({ folder: val[0] });
        this.updateFolder(val[0]);
    };

    updateFolder = async function (folder) {
        const selectedRecord = this.state.editFolder;
        const update_folder = {
            method: "PUT",
            url: constants.update_image_folder + "/" + selectedRecord.id,
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${window.localStorage.getItem("user_token")}`,
            },
            data: JSON.stringify({
                name: selectedRecord.name,
                image_path: selectedRecord.image_path,
                folder: folder ? folder : selectedRecord.folder,
                mime_type: selectedRecord.mime_type,
            }),
        };

        try {
            const resp = await axios(update_folder);
            if ([200, 201].includes(resp.status)) {
                this.cancel();
                Alert.success("Image Folder Updated Successfully.", constants.alertDuration);
            }
        } catch (error) {
            console.log(error);
            if ([406].includes(error.response.data.statusCode)) {
                Alert.error(error.response.data.message, constants.alertDuration);
            }
        }
    };

    render() {
        const { allowedFileFormats, allowedFileSize, selectedFiles = [] } = this.props;
        const library_data = this.props.library_data.filter((data) => data["mime_type"] !== "application/directory");
        // for (const data of this.props.library_data) {
        //   if (data["mime_type"] !== "application/directory") {
        //     library_data.push(data);
        //   }
        // }
        return (
            <Modal open={this.props.library_modal} onCancel={this.cancel} footer={null} className="library-modal-container">
                <div className="library-modal-header">
                    <div className="left">Select File</div>
                    <div className="right" onClick={this.save}>
                        <div className="logo" />
                    </div>
                </div>
                <div className="library-modal-body">
                    <div className="container-fluid">
                        <div className="body-title">Total Files({library_data.length})</div>
                        <div className="row">
                            {library_data.map((data, index) => {
                                let isDisabled =
                                    (selectedFiles && selectedFiles.includes(data["image_path"])) ||
                                    (allowedFileFormats.length && !allowedFileFormats.includes(data.mime_type)) ||
                                    (allowedFileSize && data.size > allowedFileSize);
                                return (
                                    <div
                                        className="col-md-3"
                                        disabled={isDisabled}
                                        style={isDisabled ? { cursor: "not-allowed", pointerEvents: "all" } : {}}
                                    >
                                        <div
                                            style={{ marginBottom: "unset", cursor: isDisabled ? "not-allowed" : "pointer" }}
                                            className="library-modal-card d-flex"
                                            key={index}
                                            onClick={() => (isDisabled ? null : this.onSelect(data["image_path"], index))}
                                        >
                                            <div
                                                className={
                                                    "select-box " + (this.state.selected.find((o) => o.index === index) ? "active" : "")
                                                }
                                            >
                                                <div className={this.state.selected.find((o) => o.index === index) ? "logo" : ""} />
                                            </div>
                                            {data["mime_type"] && data["mime_type"].includes("video") ? (
                                                <video height="100%" width="100%" controls>
                                                    <source src={data["image_path"]} type={data["mime_type"]} />
                                                    Your browser does not support the video tag.
                                                </video>
                                            ) : (data["mime_type"] && !data["mime_type"].includes("image")) || data["mime_type"] == "" ? (
                                                <img src={fileIcon} width="50px" style={{ objectFit: "contain", margin: "auto" }} />
                                            ) : (
                                                <img src={data["image_path"]} height="100%" width="100%" style={{ objectFit: "contain" }} />
                                            )}
                                            <div className="library-modal-card-name" title={data.name.split("-")[1] || data.name}>
                                                {data.name.split("-")[1] || data.name}
                                            </div>
                                        </div>
                                        {this.context.contextState.is_folder_enabled == true ? (
                                            <span style={{ display: "flex", paddingTop: "5px" }}>
                                                <FolderFilled style={{ fontSize: "14px", color: "#6564eb" }} />
                                                <span dir="rtl" className="folderBox">
                                                    <Tooltip title={this.context.contextState.key_mapping[data.folder]}>
                                                        {this.context.contextState.key_mapping[data.folder]}
                                                    </Tooltip>
                                                </span>
                                                <i
                                                    className="fa fa-edit"
                                                    style={{ paddingTop: "2px", cursor: "pointer" }}
                                                    onClick={() => (isDisabled ? null : this.onFolderSelect(data))}
                                                ></i>
                                            </span>
                                        ) : (
                                            <div style={{ marginBottom: "30px" }}></div>
                                        )}
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>

                <RbacModal
                    onCancel={this.closeRbacFolder}
                    openForm={this.state.openFolder}
                    selectedFolder={this.selectedFolder}
                    folders_accessible={this.context.contextState.folders_accessible}
                    folder_structure={this.context.contextState.folder_structure}
                    default_folder={this.context.contextState.default_folder}
                ></RbacModal>
            </Modal>
        );
    }
}

LibraryModal.defaultProps = {
    allowedFileSize: null,
    allowedFileFormats: [],
    selectedFiles: [],
};
